export default [
    {
      // path: 'relatorios/ganhadores-admin',
      path: '',
      name: 'ganhadores-admin',
      component: () => import('./index'),
      meta: {
        visible: true,
        title: 'Ganhadores',
        breadcrumb: [
          { name: 'Home', link: 'home' },
          { name: 'Relatórios', link: 'relatorios' },
          { name: 'Ganhadores Admin'},
        ]
      }
    }
  ]